<template>
    <span
        class="employee-formatted-name"
        :class="`employee-formatted-name--${normalizedFormat}`"
    >{{ formattedName }}</span>
</template>

<script>
import nameFormat from '@/utils/employeeNameFormat';

export default {
    name: 'EmployeeFormattedName',
    inject: {
        workforceEmployeeNameFormat: {
            default: () => ({
                value: nameFormat.DEFAULT_EMPLOYEE_NAME_FORMAT
            })
        }
    },
    props: {
        employee: {
            type: Object,
            required: true
        }
    },
    computed: {
        normalizedFormat() {
            return nameFormat.normalizeEmployeeNameFormat(
                this.workforceEmployeeNameFormat.value
            );
        },
        formattedName() {
            return nameFormat.formatEmployeeName(
                this.employee,
                this.normalizedFormat
            );
        }
    }
};
</script>
